export const supportedLocales = ['de-CH', 'en'] as const;

export type Locale = typeof supportedLocales[number];
export type TranslationValues = Record<string, string | number>;

const deCH = {
  'common.all': 'Alle',
  'common.missing': 'Nicht hinterlegt',
  'common.website': 'Webseite',
  'common.openWebsite': 'Webseite öffnen',
  'common.location': 'Standort',
  'common.openLocation': 'Standort öffnen',
  'common.type': 'Typ',
  'common.locationRegion': 'Ort/Region',
  'common.services': 'Dienste',
  'common.organization': 'Organisation',
  'common.organizations': 'Organisationen',
  'common.professionals': 'Professionals',
  'common.reviews': 'Bewertungen',
  'common.completedServices': 'Erledigte Dienste',
  'common.qualifications': 'Qualifikationen',
  'common.upcoming': 'Anstehend',
  'common.requests': 'Anfragen',
  'common.completed': 'Erledigt',
  'common.jobs': 'Jobs',
  'common.search': 'Suche',
  'common.pros': 'Pros',
  'common.customer': 'Kunde',
  'common.professionalShort': 'Pro',
  'common.status': 'Status',
  'common.timeRange': 'Zeitraum',
  'common.today': 'Heute',
  'common.past': 'Vergangen',
  'common.pending': 'Offen',
  'common.sorting': 'Sortierung',
  'common.logout': 'Abmelden',
  'service.all': 'Alle',
  'service.massage': 'Massage',
  'service.kiteLesson': 'Kite-Kurs',
  'service.wingfoilLesson': 'Wingfoil-Kurs',
  'service.yoga': 'Yoga',
  'externalMode.open': 'Ohne Eingrenzungen',
  'externalMode.restricted': 'Mit Eingrenzungen',
  'externalMode.membershipOnly': 'Nur Organisationen',
  'assignment.status.pending': 'Anfrage offen',
  'assignment.status.accepted.organization': 'Bestätigt',
  'assignment.status.accepted.professional': 'Angenommen',
  'assignment.status.declined': 'Abgelehnt',
  'assignment.status.completed': 'Erledigt',
  'assignment.source.external': 'Extern',
  'assignment.source.membership': 'Organisation',
  'assignment.filter.active': 'Offen + {accepted}',
  'assignment.filter.allStatuses': 'Alle Status',
  'assignment.empty.today': 'Keine Jobs für heute.',
  'assignment.empty.current': 'Keine anstehenden Jobs.',
  'assignment.empty.past': 'Keine vergangenen Jobs.',
  'assignment.loading': 'Jobs werden geladen...',
  'search.organizationLocation': 'Organisationsstandort',
  'search.townCenter': 'Ortszentrum',
  'search.village': 'Dorf',
  'search.lagoon': 'Lagune',
  'search.currentPosition': 'Aktuelle Position',
  'search.browserLocation': 'Browser-Standort',
  'search.useCurrentPosition': 'Aktuelle Position verwenden',
  'search.externalFilter': 'Filter für externe Anfragen',
  'search.radius': 'Umkreis',
  'search.running': 'Suche läuft...',
  'search.noResults': 'Keine Professionals gefunden.',
  'search.locationUnavailable': 'Die aktuelle Position ist in diesem Browser nicht verfügbar.',
  'search.locationFailed': 'Die Position konnte nicht gelesen werden.',
  'profile.reviewAverages': 'Bewertungsdurchschnitte',
  'profile.noReviews': 'Noch keine Bewertungen vorhanden.',
  'profile.noQualifications': 'Keine Qualifikationen hinterlegt.',
  'organization.searchPlaceholder': 'Organisation suchen',
  'organization.sortOptions': 'Sortieroptionen',
  'organization.sortUpcoming': 'Nach anstehenden Jobs sortieren',
  'organization.sortCompleted': 'Nach erledigten Jobs sortieren',
  'organization.resetSorting': 'Sortierung zurücksetzen',
  'organization.noneFound': 'Keine Organisation gefunden.',
  'review.link': 'Bewertungslink',
  'navigation.main': 'Hauptnavigation',
  'session.noContext': 'Für dieses Konto ist noch kein Arbeitskontext eingerichtet.',
  'session.loading': 'Sitzung wird geladen...',
  'session.profileType': 'Profiltyp',
  'login.title': 'Anmelden',
  'login.googlePrepared': 'Google-Anbindung ist vorbereitet',
  'login.applePrepared': 'Apple-Anbindung ist vorbereitet',
  'login.orEmail': 'oder mit E-Mail',
  'login.email': 'E-Mail-Adresse',
  'login.password': 'Passwort',
  'login.running': 'Anmeldung läuft...',
  'login.organizationDemo': 'Organisation-Demo',
  'login.professionalDemo': 'Professional-Demo',
  'login.noAccount': 'Noch kein Konto?',
  'login.createAccount': 'Konto erstellen',
  'register.title': 'Konto erstellen',
  'register.intro': 'Wählen Sie, wie Sie Availora nutzen möchten.',
  'register.typeLegend': 'Ich registriere mich als',
  'register.type.professional': 'Profi',
  'register.type.professionalHint': 'Ich biete Dienste an, z. B. Kurse, Massagen oder Yoga.',
  'register.type.organization': 'Organisation',
  'register.type.organizationHint': 'Wir buchen Profis für unser Business, z. B. Hostel, Schule oder Spa.',
  'register.section.profile': 'Profil',
  'register.section.organization': 'Organisation',
  'register.section.location': 'Standort',
  'register.section.access': 'Zugangsdaten',
  'register.fullName': 'Vor- und Nachname',
  'register.contactName': 'Ihr Name (Ansprechperson)',
  'register.jobTitle': 'Berufsbezeichnung',
  'register.jobTitlePlaceholder': 'z. B. Kitesurf-Instruktor',
  'register.services': 'Angebotene Dienste',
  'register.servicesRequired': 'Bitte mindestens einen Dienst auswählen.',
  'register.languages': 'Sprachen',
  'register.optional': 'optional',
  'register.organizationName': 'Name der Organisation',
  'register.organizationType': 'Art der Organisation',
  'register.organizationTypePlaceholder': 'z. B. Hostel, Kiteschule, Spa',
  'register.locationHint': 'Ort aus der Liste wählen oder die aktuelle Position übernehmen.',
  'register.locationRequired': 'Bitte einen Ort aus der Liste wählen oder die aktuelle Position übernehmen.',
  'register.useCurrentPosition': 'Aktuelle Position übernehmen',
  'register.locating': 'Position wird ermittelt...',
  'register.positionApplied': 'Genaue Position übernommen',
  'register.passwordHint': 'Mindestens 10 Zeichen.',
  'register.showPassword': 'Passwort anzeigen',
  'register.hidePassword': 'Passwort verbergen',
  'register.submit': 'Konto erstellen',
  'register.running': 'Konto wird erstellt...',
  'register.haveAccount': 'Bereits registriert?',
  'access.title': 'Geschützter Zugang',
  'access.password': 'Zugangspasswort',
  'access.open': 'Zugang öffnen',
  'error.accessNotConfigured': 'Der Zugangsschutz ist nicht konfiguriert.',
  'error.accessPasswordInvalid': 'Das Zugangspasswort ist nicht korrekt.',
  'error.dataLoad': 'Daten konnten nicht geladen werden.',
  'error.jobsLoad': 'Jobs konnten nicht geladen werden.',
  'error.search': 'Die Suche konnte nicht ausgeführt werden.',
  'error.loginUnavailable': 'Die Anmeldung ist momentan nicht möglich.',
  'error.api': 'API-Fehler {status}',
  'error.validationFailed': 'Die Eingabe ist ungültig.',
  'error.authTokenMissing': 'Der Anmeldetoken fehlt.',
  'error.authSessionInvalid': 'Die Sitzung ist ungültig oder abgelaufen.',
  'error.authContextRequired': 'Ein gültiger Availora-Kontext fehlt.',
  'error.authContextForbidden': 'Dieser Kontext gehört nicht zum angemeldeten Benutzer.',
  'error.authCredentialsInvalid': 'E-Mail-Adresse oder Passwort ist falsch.',
  'error.authUserInactive': 'Das Benutzerkonto ist nicht mehr aktiv.',
  'error.authRefreshInvalid': 'Die Sitzung kann nicht erneuert werden. Bitte erneut anmelden.',
  'error.authProviderInvalid': 'Die Anmeldung beim externen Anbieter ist ungültig.',
  'error.authProviderNotConfigured': 'Der externe Login-Anbieter ist noch nicht konfiguriert.',
  'error.authEmailTaken': 'Für diese E-Mail-Adresse besteht bereits ein Konto. Bitte anmelden.',
  'error.registrationServiceInvalid': 'Mindestens ein gewählter Dienst ist nicht verfügbar.',
  'error.registrationUnavailable': 'Die Registrierung ist momentan nicht möglich.',
  'error.rateLimitExceeded': 'Zu viele Anfragen. Bitte später erneut versuchen.',
  'error.professionalSearchForbidden': 'Die offene Professional-Suche steht Businesses zur Verfügung.',
  'error.professionalDetailForbidden': 'Dieses Professional-Profil darf nicht angezeigt werden.',
  'error.professionalUpdateForbidden': 'Das Professional-Profil kann nur im eigenen Kontext geändert werden.',
  'error.assignmentContextInvalid': 'Externe Anfragen können nur im Organization-Kontext erstellt werden.',
  'error.assignmentTimeRangeInvalid': 'Das Ende muss nach dem Beginn liegen.',
  'error.assignmentCreateFailed': 'Das Assignment konnte nicht erstellt werden.',
  'error.assignmentNotFound': 'Das Assignment wurde nicht gefunden.',
  'error.assignmentResponseForbidden': 'Nur der betroffene Professional kann auf diese Anfrage antworten.',
  'error.assignmentStatusInvalid': 'Nur offene Assignment-Anfragen können beantwortet werden.',
  'error.assignmentTimeConflict': 'Der Zeitraum überschneidet sich mit einer bestehenden Belegung.',
  'error.professionalNotFound': 'Der Professional wurde nicht gefunden.',
  'error.externalRequestsDisabled': 'Dieser Professional nimmt keine externen Anfragen an.',
  'error.serviceNotOffered': 'Der Professional bietet den gewählten Service nicht an.',
  'error.availabilityForbidden': 'Verfügbarkeit kann nur im eigenen Professional-Kontext gepflegt werden.',
  'error.availabilityNotFound': 'Die Verfügbarkeitsperiode wurde nicht gefunden.',
  'error.availabilityTimeRangeInvalid': 'Das Ende der Verfügbarkeit muss nach dem Beginn liegen.',
  'error.pushTokenNotFound': 'Das Push-Gerät wurde nicht gefunden.',
  'review.criteria.reliability': 'Zuverlässigkeit',
  'review.criteria.communication': 'Kommunikation',
  'review.criteria.professionalism': 'Professionalität',
  'review.criteria.quality': 'Qualität',
  'review.criteria.safety': 'Sicherheit',
  'review.criteria.experience': 'Erfahrung',
  'review.criteria.relaxation': 'Entspannung'
} as const;

export type TranslationKey = keyof typeof deCH;

const en: Record<TranslationKey, string> = {
  'common.all': 'All',
  'common.missing': 'Not provided',
  'common.website': 'Website',
  'common.openWebsite': 'Open website',
  'common.location': 'Location',
  'common.openLocation': 'Open location',
  'common.type': 'Type',
  'common.locationRegion': 'Location/region',
  'common.services': 'Services',
  'common.organization': 'Organization',
  'common.organizations': 'Organizations',
  'common.professionals': 'Professionals',
  'common.reviews': 'Reviews',
  'common.completedServices': 'Completed services',
  'common.qualifications': 'Qualifications',
  'common.upcoming': 'Upcoming',
  'common.requests': 'Requests',
  'common.completed': 'Completed',
  'common.jobs': 'Jobs',
  'common.search': 'Search',
  'common.pros': 'Pros',
  'common.customer': 'Customer',
  'common.professionalShort': 'Pro',
  'common.status': 'Status',
  'common.timeRange': 'Time range',
  'common.today': 'Today',
  'common.past': 'Past',
  'common.pending': 'Open',
  'common.sorting': 'Sorting',
  'common.logout': 'Log out',
  'service.all': 'All',
  'service.massage': 'Massage',
  'service.kiteLesson': 'Kite lesson',
  'service.wingfoilLesson': 'Wingfoil lesson',
  'service.yoga': 'Yoga',
  'externalMode.open': 'No restrictions',
  'externalMode.restricted': 'With restrictions',
  'externalMode.membershipOnly': 'Organizations only',
  'assignment.status.pending': 'Request open',
  'assignment.status.accepted.organization': 'Confirmed',
  'assignment.status.accepted.professional': 'Accepted',
  'assignment.status.declined': 'Declined',
  'assignment.status.completed': 'Completed',
  'assignment.source.external': 'External',
  'assignment.source.membership': 'Organization',
  'assignment.filter.active': 'Open + {accepted}',
  'assignment.filter.allStatuses': 'All statuses',
  'assignment.empty.today': 'No jobs for today.',
  'assignment.empty.current': 'No upcoming jobs.',
  'assignment.empty.past': 'No past jobs.',
  'assignment.loading': 'Loading jobs...',
  'search.organizationLocation': 'Organization location',
  'search.townCenter': 'Town centre',
  'search.village': 'Village',
  'search.lagoon': 'Lagoon',
  'search.currentPosition': 'Current position',
  'search.browserLocation': 'Browser location',
  'search.useCurrentPosition': 'Use current position',
  'search.externalFilter': 'External request filter',
  'search.radius': 'Radius',
  'search.running': 'Searching...',
  'search.noResults': 'No professionals found.',
  'search.locationUnavailable': 'The current position is not available in this browser.',
  'search.locationFailed': 'The position could not be read.',
  'profile.reviewAverages': 'Review averages',
  'profile.noReviews': 'No reviews available yet.',
  'profile.noQualifications': 'No qualifications provided.',
  'organization.searchPlaceholder': 'Search organization',
  'organization.sortOptions': 'Sort options',
  'organization.sortUpcoming': 'Sort by upcoming jobs',
  'organization.sortCompleted': 'Sort by completed jobs',
  'organization.resetSorting': 'Reset sorting',
  'organization.noneFound': 'No organization found.',
  'review.link': 'Review link',
  'navigation.main': 'Main navigation',
  'session.noContext': 'No working context is configured for this account.',
  'session.loading': 'Loading session...',
  'session.profileType': 'Profile type',
  'login.title': 'Sign in',
  'login.googlePrepared': 'Google sign-in is prepared',
  'login.applePrepared': 'Apple sign-in is prepared',
  'login.orEmail': 'or with email',
  'login.email': 'Email address',
  'login.password': 'Password',
  'login.running': 'Signing in...',
  'login.organizationDemo': 'Organization demo',
  'login.professionalDemo': 'Professional demo',
  'login.noAccount': 'No account yet?',
  'login.createAccount': 'Create account',
  'register.title': 'Create account',
  'register.intro': 'Choose how you want to use Availora.',
  'register.typeLegend': 'I am signing up as',
  'register.type.professional': 'Professional',
  'register.type.professionalHint': 'I offer services such as lessons, massages or yoga.',
  'register.type.organization': 'Organization',
  'register.type.organizationHint': 'We book professionals for our business, e.g. a hostel, school or spa.',
  'register.section.profile': 'Profile',
  'register.section.organization': 'Organization',
  'register.section.location': 'Location',
  'register.section.access': 'Sign-in details',
  'register.fullName': 'Full name',
  'register.contactName': 'Your name (contact person)',
  'register.jobTitle': 'Job title',
  'register.jobTitlePlaceholder': 'e.g. Kitesurf instructor',
  'register.services': 'Services offered',
  'register.servicesRequired': 'Please select at least one service.',
  'register.languages': 'Languages',
  'register.optional': 'optional',
  'register.organizationName': 'Organization name',
  'register.organizationType': 'Type of organization',
  'register.organizationTypePlaceholder': 'e.g. hostel, kite school, spa',
  'register.locationHint': 'Choose a place from the list or use your current position.',
  'register.locationRequired': 'Please choose a place from the list or use your current position.',
  'register.useCurrentPosition': 'Use current position',
  'register.locating': 'Locating...',
  'register.positionApplied': 'Exact position applied',
  'register.passwordHint': 'At least 10 characters.',
  'register.showPassword': 'Show password',
  'register.hidePassword': 'Hide password',
  'register.submit': 'Create account',
  'register.running': 'Creating account...',
  'register.haveAccount': 'Already registered?',
  'access.title': 'Protected access',
  'access.password': 'Access password',
  'access.open': 'Open access',
  'error.accessNotConfigured': 'Access protection is not configured.',
  'error.accessPasswordInvalid': 'The access password is incorrect.',
  'error.dataLoad': 'The data could not be loaded.',
  'error.jobsLoad': 'The jobs could not be loaded.',
  'error.search': 'The search could not be completed.',
  'error.loginUnavailable': 'Sign-in is currently unavailable.',
  'error.api': 'API error {status}',
  'error.validationFailed': 'The input is invalid.',
  'error.authTokenMissing': 'The access token is missing.',
  'error.authSessionInvalid': 'The session is invalid or has expired.',
  'error.authContextRequired': 'A valid Availora context is missing.',
  'error.authContextForbidden': 'This context does not belong to the signed-in user.',
  'error.authCredentialsInvalid': 'The email address or password is incorrect.',
  'error.authUserInactive': 'The user account is no longer active.',
  'error.authRefreshInvalid': 'The session cannot be renewed. Please sign in again.',
  'error.authProviderInvalid': 'The external provider sign-in is invalid.',
  'error.authProviderNotConfigured': 'The external sign-in provider is not configured yet.',
  'error.authEmailTaken': 'An account already exists for this email address. Please sign in.',
  'error.registrationServiceInvalid': 'At least one selected service is not available.',
  'error.registrationUnavailable': 'Registration is currently unavailable.',
  'error.rateLimitExceeded': 'Too many requests. Please try again later.',
  'error.professionalSearchForbidden': 'Open professional search is available to businesses.',
  'error.professionalDetailForbidden': 'This professional profile cannot be displayed.',
  'error.professionalUpdateForbidden': 'The professional profile can only be changed in its own context.',
  'error.assignmentContextInvalid': 'External requests can only be created in an organization context.',
  'error.assignmentTimeRangeInvalid': 'The end must be after the start.',
  'error.assignmentCreateFailed': 'The assignment could not be created.',
  'error.assignmentNotFound': 'The assignment was not found.',
  'error.assignmentResponseForbidden': 'Only the assigned professional can respond to this request.',
  'error.assignmentStatusInvalid': 'Only open assignment requests can be answered.',
  'error.assignmentTimeConflict': 'The time range overlaps with an existing booking.',
  'error.professionalNotFound': 'The professional was not found.',
  'error.externalRequestsDisabled': 'This professional does not accept external requests.',
  'error.serviceNotOffered': 'The professional does not offer the selected service.',
  'error.availabilityForbidden': 'Availability can only be managed in the professional context.',
  'error.availabilityNotFound': 'The availability period was not found.',
  'error.availabilityTimeRangeInvalid': 'The availability end must be after the start.',
  'error.pushTokenNotFound': 'The push device was not found.',
  'review.criteria.reliability': 'Reliability',
  'review.criteria.communication': 'Communication',
  'review.criteria.professionalism': 'Professionalism',
  'review.criteria.quality': 'Quality',
  'review.criteria.safety': 'Safety',
  'review.criteria.experience': 'Experience',
  'review.criteria.relaxation': 'Relaxation'
};

const dictionaries: Record<Locale, Record<TranslationKey, string>> = {
  'de-CH': deCH,
  en
};

export type TranslationFunction = (key: TranslationKey, values?: TranslationValues) => string;

/** Löst einen typisierten Schlüssel auf und ersetzt einfache {platzhalter}. */
export function translate(locale: Locale, key: TranslationKey, values: TranslationValues = {}): string {
  const template = dictionaries[locale][key] ?? dictionaries['de-CH'][key];
  return Object.entries(values).reduce(
    (text, [name, value]) => text.split(`{${name}}`).join(String(value)),
    template
  );
}
